<header class="page_header">
    <div class="header_content">
        <div class="text_and_supporting_text">
            <div class="page_title">Vehicle Type Master</div>
        </div>
        <div class="action_btn " *RequiresPermission="{permissionIds: [PermissionConstants.MASTERS.VEHICLETYPE_MASTER.CREATE]}">
            <button class="add_new_btn" (click)="addVehicle() " >
                <img src="assets/icons/plus_icon.svg" height="20" width="20">Add New
            </button>
        </div>
    </div>
</header>



<app-tos-table
*RequiresPermission="{permissionIds: [PermissionConstants.MASTERS.VEHICLETYPE_MASTER.LIST]}; fallback: true"   
[stats]="tableStats"
[filterConfig]="VehicleMasterMetaConfig.filterConfig"
[searchBarConfig]="VehicleMasterMetaConfig.searchBarConfig"
[showTableStats]="true"
[tableMeta]="tableMeta"
[tableMenuOptions]="menuOptions"
[(dataListRequest)]="tableListRequest"
[dataListResponse]="tableListData"
[(selectedItems)]="selectedItems"
(tosTableAction)="fetchAllRecords()"
(tableMenuOptionSelected)="handleOptionSelected($event)"
></app-tos-table>
